import React, { useState } from "react";
import { FaHome, FaQuestionCircle } from "react-icons/fa";
import FAQ from "./components/Faq";

const ShippingInfo = () => {
  const popupContents = {
    isim: "Adınızı giriniz.",
    soyisim: "Soyadınızı giriniz.",
    tckimlik: "11 haneli T.C. kimlik numaranızı giriniz.",
    imei: "Cihazınızın IMEI numarasını giriniz.",
    telefon: "Telefon numaranızı giriniz.",
    email: "Geçerli bir e-posta adresi giriniz.",
    sehir: "Yaşadığınız şehri seçiniz.",
    ilce: "Yaşadığınız ilçeyi seçiniz.",
    mahalle: "Yaşadığınız mahalleyi seçiniz.",
    adres: "Tam adresinizi giriniz.",
  };

  const [popupContent, setPopupContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
    setIsClosing(false);
  };

  const closeModal = () => {
    setIsClosing(true);
    setTimeout(() => setIsModalOpen(false), 300);
  };

  const openPopup = (content) => {
    setPopupContent(content);
  };

  const closePopup = () => {
    setPopupContent(null);
  };
  return (
    <div className="bg-black text-white">
      <div className="container mx-auto pt-32 pb-10 px-4">
        <div className="text-center mb-10">
          <h2 className="text-2xl font-medium">Gönderi Bilgileri</h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5 border border-gray-500 rounded-lg p-6 space-y-6">
            <div className="flex items-center space-x-6 p-4 bg-gray-900 rounded-lg border border-gray-500">
              <img
                src="https://cihaz-sat.easycep.com/images/webp/iphone_telefon.webp"
                alt="Cihaz Görseli"
                className="w-40 object-contain"
              />
              <div>
                <h3 className="text-xl sm:text-5xl font-bold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-transparent bg-clip-text">
                  Apple
                </h3>
                <h4 className="text-xl sm:text-5xl font-semibold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-transparent bg-clip-text">
                  iPhone 11
                </h4>
                <span className="text-xl sm:text-5xl font-semibold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-transparent bg-clip-text">
                  Pro Max
                </span>
              </div>
            </div>

            <div className="border border-gray-500 rounded-lg p-3 bg-gray-800 text-left space-y-4">
              <h3 className="text-4xl font-semibold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-transparent bg-clip-text">
                Cevaplarınız
              </h3>
              <div className="space-y-2">
                {[
                  { question: "Cihazın hafızası kaç GB?", answer: "128 GB" },
                  {
                    question: "Ürünün açılmasında problem var mı?",
                    answer: "Evet",
                  },
                  {
                    question:
                      "Ürünün çevresinde/kasasinda eziklik, aşınma veya kırık var mı?",
                    answer: "Hayır",
                  },
                  {
                    question: "Ürünün ekranı kırık mı? Eksik piksel var mı?",
                    answer: "Evet",
                  },
                  {
                    question:
                      "Ürünün parmak izi okumada veya yüz tanımada problemi var mı?",
                    answer: "Evet",
                  },
                  {
                    question: "Ürünün arka kamerasında problem var mı?",
                    answer: "Evet",
                  },
                  {
                    question: "Ürünün ön kamerasında problem var mı?",
                    answer: "Evet",
                  },
                ].map((item, index) => (
                  <div key={index} className="p-2 bg-gray-900 rounded-md">
                    <p className="text-sm font-medium text-gray-200">
                      {item.question}
                    </p>
                    <p className="text-sm text-gray-400">{item.answer}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="border border-gray-500 rounded-lg p-1 text-center">
              Promosyon Kodu Giriş Alanı
            </div>
            <div className="border border-gray-500 rounded-lg p-1 text-center">
              Hediye Çeki Oluştur Seçeneği
            </div>
            <div className="border border-gray-500 rounded-lg p-1 text-center">
              <h3 className="text-xl font-semibold">Ön Teklif</h3>
              <p className="text-2xl font-bold text-green-400">9750 ₺</p>
            </div>
          </div>
          <div className="lg:col-span-7 border border-gray-500 rounded-lg p-6 bg-gray-800">
            <form className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* İsim */}
              <div className="flex flex-col">
                <div className="flex items-center">
                  <label className="text-sm mb-1">İsim</label>
                  <FaQuestionCircle
                    className="ml-2 text-blue-500 cursor-pointer mb-1"
                    onClick={() => openPopup(popupContents.isim)}
                  />
                </div>
                <input
                  type="text"
                  placeholder="İsim"
                  className="bg-gray-900 p-2 border border-gray-500 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                />
              </div>

              {/* Soy İsim */}
              <div className="flex flex-col">
                <div className="flex items-center">
                  <label className="text-sm mb-1">Soy İsim</label>
                  <FaQuestionCircle
                    className="ml-2 text-blue-500 cursor-pointer mb-1"
                    onClick={() => openPopup(popupContents.soyisim)}
                  />
                </div>
                <input
                  type="text"
                  placeholder="Soy İsim"
                  className="bg-gray-900 p-2 border border-gray-500 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                />
              </div>

              {/* T.C. Kimlik Numarası */}
              <div className="flex flex-col">
                <div className="flex items-center">
                  <label className="text-sm mb-1">T.C. Kimlik Numarası</label>
                  <FaQuestionCircle
                    className="ml-2 text-blue-500 cursor-pointer mb-1"
                    onClick={() => openPopup(popupContents.isim)}
                  />
                </div>
                <input
                  type="text"
                  placeholder="T.C. Kimlik Numaranız"
                  className="bg-gray-900 p-2 border border-gray-500 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                />
              </div>

              {/* Cihaz IMEI No */}
              <div className="flex flex-col">
                <div className="flex items-center">
                  <label className="text-sm mb-1">Cihaz IMEI No</label>
                  <FaQuestionCircle
                    className="ml-2 text-blue-500 cursor-pointer mb-1"
                    onClick={() => openPopup(popupContents.isim)}
                  />
                </div>
                <input
                  type="text"
                  placeholder="Cihaz IMEI No"
                  className="bg-gray-900 p-2 border border-gray-500 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                />
              </div>

              {/* Telefon */}
              <div className="flex flex-col">
                <div className="flex items-center">
                  <label className="text-sm mb-1">Telefon</label>
                  <FaQuestionCircle
                    className="ml-2 text-blue-500 cursor-pointer mb-1"
                    onClick={() => openPopup(popupContents.isim)}
                  />
                </div>
                <input
                  type="text"
                  placeholder="(5xx) xxx xx xx"
                  className="bg-gray-900 p-2 border border-gray-500 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                />
              </div>

              {/* E-mail */}
              <div className="flex flex-col">
                <div className="flex items-center">
                  <label className="text-sm mb-1">E-mail</label>
                  <FaQuestionCircle
                    className="ml-2 text-blue-500 cursor-pointer mb-1"
                    onClick={() => openPopup(popupContents.isim)}
                  />
                </div>
                <input
                  type="email"
                  placeholder="E-mail"
                  className="bg-gray-900 p-2 border border-gray-500 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                />
              </div>

              {/* Şehir Seçiniz */}
              <div className="flex flex-col ">
                <div className="flex items-center">
                  <label className="text-sm mb-1">Şehir Seçiniz</label>
                  <FaQuestionCircle
                    className="ml-2 text-blue-500 cursor-pointer mb-1"
                    onClick={() => openPopup(popupContents.isim)}
                  />
                </div>
                <input
                  type="text"
                  placeholder="Şehir Seçiniz"
                  className="bg-gray-900 p-2 border border-gray-500 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                />
              </div>

              {/* İlçe Seçiniz */}
              <div className="flex flex-col ">
                <div className="flex items-center">
                  <label className="text-sm mb-1">İlçe Seçiniz</label>
                  <FaQuestionCircle
                    className="ml-2 text-blue-500 cursor-pointer mb-1"
                    onClick={() => openPopup(popupContents.isim)}
                  />
                </div>
                <input
                  type="text"
                  placeholder="İlçe Seçiniz"
                  className="bg-gray-900 p-2 border border-gray-500 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                />
              </div>

              {/* Mahalle Seçiniz */}
              <div className="flex flex-col col-span-2">
                <div className="flex items-center">
                  <label className="text-sm mb-1">Mahalle Seçiniz</label>
                  <FaQuestionCircle
                    className="ml-2 text-blue-500 cursor-pointer mb-1"
                    onClick={() => openPopup(popupContents.isim)}
                  />
                </div>
                <input
                  type="text"
                  placeholder="Mahalle Seçiniz"
                  className="bg-gray-900 p-2 border border-gray-500 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                />
              </div>

              {/* Adres Giriniz */}
              <div className="flex flex-col col-span-2">
                <div className="flex items-center">
                  <label className="text-sm mb-1">Adres Giriniz</label>
                  <FaQuestionCircle
                    className="ml-2 text-blue-500 cursor-pointer mb-1"
                    onClick={() => openPopup(popupContents.isim)}
                  />
                </div>
                <textarea
                  placeholder="Adres Giriniz"
                  className="bg-gray-900 p-2 border border-gray-500 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                  rows="4"
                />
              </div>

              {/* Onay Kutuları */}
              <div className="col-span-2 space-y-2">
                <label className="flex items-start space-x-2">
                  <input
                    type="checkbox"
                    className="mt-1 h-5 w-5 border-gray-500 rounded text-green-400 focus:ring-blue-600"
                  />
                  <span className="text-sm">
                    Kullanım Koşulları'nı ve Aydınlatma Metni'ni okudum,
                    onaylıyorum.
                  </span>
                </label>
                <label className="flex items-start space-x-2">
                  <input
                    type="checkbox"
                    className="mt-1 h-5 w-5 border-gray-500 rounded text-green-400 focus:ring-green-400"
                  />
                  <span className="text-sm">
                    Ürün Alım Sözleşmesi'ni okudum, onaylıyorum.
                  </span>
                </label>
                <label className="flex items-start space-x-2">
                  <input
                    type="checkbox"
                    className="mt-1 h-5 w-5 border-gray-500 rounded text-green-400 focus:ring-blue-600"
                  />
                  <span className="text-sm">
                    Tarafıma kampanyalar, reklam ve memnuniyet hizmetlerinden
                    haberdar edilebilmesi için Ticari Elektronik İleti Açık Rıza
                    Metni'ni onaylıyorum.
                  </span>
                </label>
              </div>

              {/* İlerle Butonu */}
              <div className="col-span-2">
                <button
                  type="button"
                  onClick={openModal} // Modal açma fonksiyonu
                  className="w-full bg-blue-600 hover:bg-blue-500 text-white p-2 rounded-lg transition"
                >
                  İlerle
                </button>
              </div>

              {isModalOpen && (
                <div
                  className={`fixed inset-0 bg-gradient-to-b from-black/5 to-black flex items-center justify-center z-50 ${
                    isClosing ? "fade-out-scale" : "fade-in-scale"
                  }`}
                  style={{
                    animation: `${
                      isClosing ? "fade-out-scale" : "fade-in-scale"
                    } 0.3s ease-in-out`,
                  }}
                >
                  <div
                    className="text-white p-4 sm:p-8 rounded-lg shadow-2xl max-w-full sm:max-w-3xl w-full relative m-4 sm:m-20 "
                    style={{
                      background:
                        "linear-gradient(to top right, #1a1a1a, #2b2b2b, #3c3c3c, #000000)",
                    }}
                  >
                    {/* Sağ üst köşedeki kapat butonu */}
                    <button
                      className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition duration-200 focus:outline-none"
                      onClick={closeModal}
                      aria-label="Close Modal"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>

                    <h2 className="text-lg sm:text-3xl font-bold mb-2">
                      Sipariş Numarası:{" "}
                      <span className="text-white font-extrabold">
                        10X15Y130701U25F
                      </span>
                    </h2>
                    <p className="text-sm sm:text-lg mb-4 sm:mb-6 text-gray-300">
                      Sipariş Tarihi:{" "}
                      <span className="text-gray-300 font-medium">
                        2025-01-07 16:15:10
                      </span>
                    </p>
                    <hr
                      style={{
                        border: "none",
                        borderTop: "1px solid #4B5563",
                        marginBottom: "14px",
                      }}
                    />

                    <div className="flex flex-col sm:flex-row">
                      {/* Sol Bölüm */}
                      <div className="flex-shrink-0 text-center mb-4 sm:mr-6 flex justify-center">
                        <div>
                          <p className="text-3xl sm:text-3xl font-semibold mb-4">
                            iPhone XS
                          </p>
                          <img
                            src="https://cdn.easycep.com/assets/_web/img/product/2022/10/l_apple-iphone-13-5259-1-1664954722.webp"
                            alt="Ürün Görseli"
                            className="w-40 sm:w-48 h-auto rounded-md"
                          />
                        </div>
                      </div>

                      {/* Sağ Bölüm */}
                      <div className="text-sm sm:text-base space-y-3 sm:space-y-4 flex-1">
                        <p>
                          Sayın{" "}
                          <span className="font-semibold text-white">
                            Ahmet Gülmez
                          </span>
                          ,{" "}
                          <span className="text-orange-400 font-semibold">
                            10X15Y130701U25F
                          </span>{" "}
                          numaralı siparişiniz başarıyla oluşturuldu.
                        </p>
                        <p>
                          Cihazınızı{" "}
                          <span className="text-white font-semibold">
                            0123456789
                          </span>{" "}
                          numaralı müşteri numarası ile en yakın Yurtiçi Kargo
                          şubesine teslim edebilir veya Yurtiçi Kargo ile
                          iletişime geçip bir kurye talebinde bulunabilirsiniz.
                        </p>
                        <p>
                          Kargolama öncesi cihazınızın var ise tüm kilitlerinin
                          kaldırıldığından lütfen emin olunuz.
                        </p>
                        <p>
                          Cihazınızı kargolarken paketleme işleminin özenli
                          olmasına dikkat ediniz.
                        </p>
                        <p>
                          Sipariş sonrası tüm işlemlerinizi Anasayfa üzerinden
                          Sipariş Durumunu Kontrol Et bölümünden sipariş
                          numaranız ile gerçekleştirebilirsiniz.
                        </p>
                        <p>
                          Bu sayfanın bir ekran görüntüsünü almanız ve sipariş
                          numaranızı kaydetmenizi öneririz.
                        </p>
                      </div>
                    </div>

                    {/* Anasayfaya Git Butonu */}
                    <div className="flex justify-center mt-4 sm:mt-6">
                      <a
                        href="/"
                        className="text-white py-2 px-3 sm:py-2 sm:px-4 rounded-lg transition flex items-center space-x-2"
                        style={{
                          background:
                            "linear-gradient(to top right, #1a1a1a, #2b2b2b, #3c3c3c, #1a1a1a)",
                        }}
                      >
                        <FaHome className="text-white" />
                        <span>Anasayfaya Git</span>
                      </a>
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
      <div className="w-full container mx-auto  p-12 bg-gray-500 border border-gray-300 rounded-2xl text-white text-center">
        Blok 1
      </div>
      {popupContent && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-2xl shadow-lg text-gray-800 max-w-md w-full relative">
            {/* Kapat Butonu */}
            <button
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition duration-200"
              onClick={closeModal}
              aria-label="Close Popup"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Popup Başlık */}
            <h3 className="text-lg font-semibold mb-4 text-center">
              Bilgilendirme
            </h3>

            {/* Popup İçeriği */}
            <p className="text-sm text-center">{popupContent}</p>

            {/* Footer ve Tamam Butonu */}
            <div className="mt-6 flex justify-center">
              <button
                className="px-6 py-2 bg-blue-500 text-white text-sm font-medium rounded-lg shadow hover:bg-blue-600 focus:ring-2 focus:ring-blue-300 focus:outline-none transition duration-200"
                onClick={closePopup}
              >
                Tamam
              </button>
            </div>
          </div>
        </div>
      )}
      <FAQ />
    </div>
  );
};

export default ShippingInfo;
